import Error from '../model/Error';
import Stationery from '../dto/Stationery';
import axios from 'axios';

export default class ClubStationeryRepository {
    static findSimpleByClub(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/stationeries`, { })
                .then((response) => resolve(response.data.data.map((data) => Stationery.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findInvoiceByClub(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/invoice-stationeries`, { })
                .then((response) => resolve(response.data.data.map((data) => Stationery.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static remove(stationeryId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/stationeries/${stationeryId}`, { })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
